import { Routes, useLocation, Route, Outlet } from 'react-router-dom';

import EmployeeList from '../employeeList/AllEmpoyee';
import EmployeeDetails from '../employeeDetail/index';
import { EmployeeProvider } from './../context/employeeContext';

function EmployeeRouter() {
  let { pathname } = useLocation();
  console.log(pathname,"HEREEEEEEE")

  return (
    <EmployeeProvider>
    <Routes>
       <Route path="/" element={<Outlet />}>
        <Route index element={<EmployeeList />} /> {/* Matches `/employees` */}

        <Route path=":id" element={<EmployeeDetails />} /> {/* Matches `/employees/:id` */}
        <Route path="/leaves" element={<EmployeeList />} /> {/* Matches `/employees` */}

      </Route>
    </Routes>
    </EmployeeProvider>
  );
}

export default EmployeeRouter;
